import { v4 as uuidv4 } from "uuid";
import type { BaseBlock } from "@circle-react-shared/BuilderUI/DataModel.types";

export const defaultData: BaseBlock = {
  id: uuidv4(),
  type: "embed",
  props: {
    embed: {
      prop: "other",
      type: "oembed",
      value: {
        url: "",
        html: "",
      },
    },
  },
};
